const SAVE = "SAVE_CART";

export function save(data) {
    return {
        type: SAVE,
        payload: data
    }
}